import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard, Building2, ClipboardList, Database,
  Activity, Mail, MailOpen, Megaphone, Settings, LogOut, X, Users, Shield, Wand2, Sparkles
} from 'lucide-react';

const navItems = [
  { label: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { label: 'Tenants', href: '/admin/tenants', icon: Building2 },
  { label: 'Gebruikers', href: '/admin/users', icon: Users },
  { label: 'Wachtlijst', href: '/admin/waitlist', icon: ClipboardList },
  { label: 'Backups', href: '/admin/backups', icon: Database },
  { label: 'Monitoring', href: '/admin/monitoring', icon: Activity },
  { label: 'Claude-kosten', href: '/admin/ai-usage', icon: Sparkles },
  { label: 'E-mail templates', href: '/admin/email-templates', icon: Mail },
  { label: 'E-mail log', href: '/admin/email-log', icon: MailOpen },
  { label: 'Aankondigingen', href: '/admin/announcements', icon: Megaphone },
  { label: 'Achtergronden', href: '/admin/backgrounds', icon: Wand2 },
  { label: 'Beveiliging', href: '/admin/security', icon: Shield },
  { label: 'Instellingen', href: '/admin/settings', icon: Settings },
];

export default function AdminSidebar({ onClose }: { onClose?: () => void }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full bg-gray-900 text-white w-64">
      <div className="flex items-center justify-between h-16 px-6 border-b border-gray-700">
        <span className="text-lg font-bold">Occiput Admin</span>
        {onClose && (
          <button onClick={onClose} className="lg:hidden text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
      <nav className="flex-1 overflow-y-auto py-4 px-3">
        <ul className="space-y-1">
          {navItems.map(item => (
            <li key={item.href}>
              <NavLink to={item.href} end={item.href === '/admin'} onClick={onClose}
                className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-brand-600 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white'}`}>
                <item.icon className="w-4 h-4" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="border-t border-gray-700 p-4">
        <p className="text-sm font-medium truncate">{user?.full_name}</p>
        <p className="text-xs text-gray-400 truncate mb-3">{user?.email}</p>
        <button
          onClick={() => { logout(); navigate('/login'); }}
          className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Uitloggen
        </button>
      </div>
    </div>
  );
}
